import * as React from 'react'
import { ONDropdown } from './ONDropdown'
import { Alert, Dropdown, Table, Icon } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import { GrPrice } from '../../../../../../utilities/helpers'

interface Props {
  mappedColumns: Map<string, boolean>
  checkedColumnIndices: string[]
  negativeProducts: NegativeProduct
  setMappedColumns: (newMappedColumns: Map<string, boolean>) => void
}

interface NegativeProductTableRecord {
  key: number
  productNameAndSku: JSX.Element
  details: JSX.Element
}

export interface NegativeProduct {
  [productId: string]: NegativeProductItem
}

export interface NegativeProductItem {
  productId: string
  productName: string
  productSKU: string
  columns: NegativeProductColumn
}

interface NegativeProductColumn {
  [name: string]: {
    unit?: number
    value?: number
  }
}

export const PreviewTableTitle = (props: Props) => {
  const { mappedColumns, checkedColumnIndices, negativeProducts, setMappedColumns } = props

  const [isDropdownVisible, setIsDropdownVisible] = React.useState(false)

  const columns: ColumnProps<NegativeProductTableRecord>[] = [
    {
      title: 'Name (SKU)',
      dataIndex: 'productNameAndSku',
      key: 'productNameAndSku',
    },
    {
      title: 'Details',
      dataIndex: 'details',
      key: 'details',
    },
  ]

  const dataSource: NegativeProductTableRecord[] = Object.keys(negativeProducts).map(
    (objKey, index) => {
      const objValue = negativeProducts[objKey]

      return {
        key: index,
        productNameAndSku: (
          <div>
            <div>{objValue.productName}</div>
            <small className='text-muted'>{objValue.productSKU}</small>
          </div>
        ),
        details: (
          <ul
            style={{
              paddingLeft: 20,
              marginBottom: 0,
            }}
          >
            {Object.keys(objValue.columns).map((columnName, key) => {
              const { unit, value } = objValue.columns[columnName]

              return (
                <li key={key}>
                  <b style={{ color: 'var(--red)' }}>{columnName}</b>
                  <span> has </span>
                  {unit !== undefined && <span>{unit}</span>}
                  {value !== undefined && <span> ({GrPrice.convertDollarToDollar(value)})</span>}
                </li>
              )
            })}
          </ul>
        ),
      }
    },
  )

  return (
    <div className='d-flex flex-wrap align-items-center' style={{ marginBottom: -16 }}>
      <ONDropdown
        wrapperClassName='mr-3 mb-3'
        mappedColumns={mappedColumns}
        checkedColumnIndices={checkedColumnIndices}
        setMappedColumns={setMappedColumns}
      />

      {Object.keys(negativeProducts).length > 0 && (
        <Dropdown
          trigger={['click']}
          visible={isDropdownVisible}
          placement='topLeft'
          overlay={
            <div
              className='background-white text-right'
              style={{
                WebkitBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                WebkitTransform: 'translate3d(0, 0, 0)',
              }}
            >
              <Icon
                type='close'
                className='p-3 text-right'
                onClick={() => setIsDropdownVisible(false)}
              />

              <Table
                bordered
                size='middle'
                dataSource={dataSource}
                columns={columns}
                className='pl-3 pt-0 pr-3 pb-3 no-background-table'
                rowClassName={() => 'background-white'}
                pagination={{
                  style: { marginTop: 0 },
                  pageSize: 4,
                  position: 'top',
                  hideOnSinglePage: true,
                  showTotal: (total) => `Total ${total} products`,
                }}
              />
            </div>
          }
        >
          <Alert
            className='mb-3'
            message={
              <span className='d-flex justify-content-between flex-wrap'>
                <span className='mr-3'>
                  <b>{Object.keys(negativeProducts).length}</b>
                  <span> negative values found</span>
                </span>

                <span
                  style={{ color: 'var(--blue)' }}
                  className='cursor-pointer'
                  onClick={() => setIsDropdownVisible(!isDropdownVisible)}
                >
                  {isDropdownVisible ? 'Close' : 'See more'}
                </span>
              </span>
            }
            type='error'
            showIcon
          />
        </Dropdown>
      )}
    </div>
  )
}
